import API from 'src/api';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { AttachmentsType } from 'src/types';
import { SagaAction } from '../../types';
import { deleteUserFile } from '../actions';
import { selectUser, selectUserUuid } from '../selectors';
import { setUser, setUserUuid } from '../reducers';

type AttachmentKey = keyof AttachmentsType;

const removeAttachmentById = (attachments: AttachmentsType, targetId: number): AttachmentsType => {
  const newAttachments: AttachmentsType = {};

  for (const [key, details] of Object.entries(attachments)) {
    if (details && details.id !== targetId) {
      newAttachments[key as AttachmentKey] = details;
    }
  }
  return newAttachments;
};

function* deleteUserUploadSaga({ payload }: SagaAction<{ id: number }>): SagaIterator {
  const user = yield select(selectUser);
  const userById = yield select(selectUserUuid);
  const isUpdatedOnBehalf = userById.uuid && userById.uuid !== user.uuid;
  const updatedAttachments = isUpdatedOnBehalf
    ? removeAttachmentById(userById.attachments, payload.id)
    : removeAttachmentById(user.attachments, payload.id);

  try {
    yield put(deleteUserFile.pending());
    yield call(API.deleteUserUpload, payload);

    if (isUpdatedOnBehalf) {
      yield put(
        setUserUuid({
          ...userById,
          attachments: {
            ...updatedAttachments,
          },
        }),
      );
    } else {
      yield put(
        setUser({
          ...user,
          attachments: {
            ...updatedAttachments,
          },
        }),
      );
    }

    yield put(deleteUserFile.success());
  } catch (error) {
    yield put(deleteUserFile.failure(error));
  }
}

export default deleteUserUploadSaga;
